import { render, staticRenderFns } from "./widgetSelect.vue?vue&type=template&id=02079e77&scoped=true"
import script from "./widgetSelect.vue?vue&type=script&lang=js"
export * from "./widgetSelect.vue?vue&type=script&lang=js"
import style0 from "./widgetSelect.vue?vue&type=style&index=0&id=02079e77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02079e77",
  null
  
)

export default component.exports